import { useEffect, useState } from 'react';

/** A tiny router for the few challenge pages: no library for four routes. */

export type Route =
  { page: 'new' } | { page: 'challenge'; code: string } | { page: 'chat' } | { page: 'not_found' };

export function parseRoute(path: string): Route {
  const clean = path.replace(/\/+$/, '') || '/';
  if (clean === '/reto' || clean === '/reto/nuevo') return { page: 'new' };
  const m = /^\/reto\/([a-z2-9]{8})$/.exec(clean.toLowerCase());
  if (m) return { page: 'challenge', code: m[1]! };
  if (clean.startsWith('/reto/')) return { page: 'not_found' };
  return { page: 'chat' };
}

export function navigate(path: string): void {
  history.pushState(null, '', path);
  dispatchEvent(new PopStateEvent('popstate'));
}

export function usePath(): string {
  const [path, setPath] = useState(() => location.pathname);
  useEffect(() => {
    const onPop = () => setPath(location.pathname);
    addEventListener('popstate', onPop);
    return () => removeEventListener('popstate', onPop);
  }, []);
  return path;
}
